import BaseNavigationTabs from 'components/Navigation/BaseNavigationTabs';
import BaseNavigationTabsButton from 'components/Navigation/BaseNavigationTabs/BaseNavigationTabsButton';
import {NavigationTabsPropsHelper} from 'components/Navigation/BaseNavigationTabs/types';
import TooltipWrapper from 'components/Tooltip';
import {FC} from 'react';
import {c} from 'ttag';
import {ObjectPermissions} from 'types/permissions';

export type TeamMemberPermissions = Partial<
    ObjectPermissions<
        'employeeRights' | 'groups' | 'notifications' | 'overview'
    >
>;

type NavigationTabsTeamMemberProps = NavigationTabsPropsHelper<
    {
        mid: string;
    } & TeamMemberPermissions
>;

const NavigationTabsTeamMember: FC<NavigationTabsTeamMemberProps> = ({
    className,
    employeeRights,
    groups,
    mid,
    notifications,
    overview,
    selection,
}) => (
    <BaseNavigationTabs className={className} selection={selection}>
        {overview && (
            <TooltipWrapper message={overview.failureReason}>
                <BaseNavigationTabsButton
                    disabled={!overview.allowed}
                    href={window.Urls.employee_item_view(mid)}
                    label={c('component').t`Overview`}
                    name="overview"
                />
            </TooltipWrapper>
        )}
        {employeeRights && (
            <TooltipWrapper message={employeeRights.failureReason}>
                <BaseNavigationTabsButton
                    disabled={!employeeRights.allowed}
                    href={window.Urls.member_rights_view(mid)}
                    label={c('component').t`Employee Rights`}
                    name="employeeRights"
                />
            </TooltipWrapper>
        )}
        {notifications && (
            <TooltipWrapper message={notifications.failureReason}>
                <BaseNavigationTabsButton
                    disabled={!notifications.allowed}
                    href={window.Urls.team_notification_employee_mid_react_view(
                        mid,
                    )}
                    label={c('component').t`Notifications`}
                    name="notifications"
                />
            </TooltipWrapper>
        )}
        {groups && (
            <TooltipWrapper message={groups.failureReason}>
                <BaseNavigationTabsButton
                    disabled={!groups.allowed}
                    href={window.Urls.team_member_groups_react_view(mid)}
                    label={c('component').t`Groups`}
                    name="groups"
                />
            </TooltipWrapper>
        )}
    </BaseNavigationTabs>
);

export default NavigationTabsTeamMember;
